import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { languages } from '../../../../configs/language'
import { Element } from '../../../common/html/element'
import { Popup } from '../../../common/popup'
import EventEmitter, { UPDATE_LOADING_PDF } from '../../../helpers/EventEmitter'
import classes from '../index.module.scss'

const LoadingPdf = ({ setDefault, localeSystem }) => {
  const [percent, setPercent] = useState(0)

  useEffect(() => {
    EventEmitter.subscribe(UPDATE_LOADING_PDF, setPercent)
    return () => EventEmitter.unsubscribe(UPDATE_LOADING_PDF, setPercent)
  }, [])

  const isEn = localeSystem === languages.en

  return (
    <Popup
      appendStyleContent={{
        padding: '24px',
        backgroundColor: '#F3F3F3',
        width: 360,
        borderRadius: '4px',
      }}
    >
      <div className={classes.loadingPdfContainer}>
        <Element className="fw600" style={{ color: '#191D25', fontSize: 24 }}>
          {isEn ? 'Loading...' : 'Đang tải...'}
        </Element>
        <div className={classes.mt12}>
          {isEn ? 'Please wait!' : 'Vui lòng chờ trong giây lát!'}
        </div>
        <Element
          style={{ backgroundColor: '#ECECEC' }}
          className={classes.barContainer}
        >
          <Element
            className={classes.bar}
            style={{
              backgroundColor: '#2C73E8',
              width: `calc((100% - 8px) * ${percent})`,
            }}
          />
        </Element>
        <div className="mt3 dFlex justifyContentEnd">
          <Element
            className={classes.btn}
            style={{ border: '1px solid #D5D5D5' }}
            onClick={setDefault}
          >
            {isEn ? 'Cancel' : 'Hủy bỏ'}
          </Element>
        </div>
      </div>
    </Popup>
  )
}

LoadingPdf.propTypes = {
  setDefault: PropTypes.func.isRequired,
  localeSystem: PropTypes.string.isRequired,
}

export default LoadingPdf
